import React from 'react';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import { Icon } from '@/components/ui/icon';
import { Button } from '@/components/ui/button';

const { FiLock, FiHome, FiAlertCircle } = FiIcons;

const Forbidden = () => {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4">
      <div className="text-center max-w-md">
        <div className="mb-8">
          <Icon icon={FiLock} color="danger" size="3xl" className="mx-auto mb-4" />
          <h1 className="text-foreground text-6xl font-bold mb-4">403</h1>
          <h2 className="text-foreground text-2xl font-semibold mb-4">Access Denied</h2>
          <p className="text-muted-foreground mb-8">
            You don't have permission to access this page. Please contact your administrator if you think this is a mistake.
          </p>
        </div>

        <div className="space-y-4">
          <div className="flex justify-center gap-4">
            <Button asChild className="gap-2">
              <Link to="/">
                <Icon icon={FiHome} color="white" />
                <span>Back to Dashboard</span>
              </Link>
            </Button>

            <Button variant="outline" onClick={() => window.history.back()}>
              Go Back
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Forbidden;